<template>
  <div>
    <img src="https://jeffjames.s3.us-west-2.amazonaws.com/christmas2024.jpg" border="0" alt="Merry Christmas!" />
  </div>
</template>
